var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      class: { hidden: _vm.isModalHidden },
      attrs: {
        name: _vm.modalName,
        width: "100%",
        height: "100%",
        clickToClose: false,
      },
      on: { opened: _vm.handleDialogOpened, closed: _vm.hideModal },
    },
    [
      _c("subscription-plan-view", {
        attrs: { viewType: "dialog", type: _vm.type },
        on: {
          showView: function ($event) {
            _vm.isModalHidden = false
          },
          onGetQuote: _vm.showQuoteModal,
          closeView: _vm.hideModal,
          freePlanSelected: _vm.hideModal,
        },
      }),
      _vm._v(" "),
      _c("quote-request-modal", {
        attrs: { show: _vm.isQuoteModalOpened },
        on: { onClose: _vm.closeQuoteModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }